import { motion, AnimatePresence } from 'framer-motion'
import { pxToNumber } from '@/utils/pxToNumber'
import { theme } from '@lounge-fe/tailwind'
import { Image } from '@lounge-fe/ui-kit'

import { SignupFormLayoutMediaProps } from './types'
import { twMerge } from 'tailwind-merge'

export const Media = ({
  image,
  video,
  className,
}: SignupFormLayoutMediaProps) => {
  return (
    <div
      className={twMerge(
        'w-full h-full overflow-hidden inset-0 relative',
        className,
      )}
    >
      <AnimatePresence>
        <motion.div
          key={video?.id ?? image?.src}
          className="w-full h-full overflow-hidden absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          {video ? (
            <video
              autoPlay={true}
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
              poster={video.preview_image.src}
              title={video.alt}
            >
              {video.sources
                .sort((a, b) => b.height - a.height)
                .map(({ url, mime_type, height }, idx) => (
                  <source
                    key={idx}
                    src={url}
                    type={mime_type}
                    height={height}
                  />
                ))}
            </video>
          ) : image ? (
            <Image
              key={image.src}
              data={{ src: image.src, width: pxToNumber(theme.screens.sm) }}
              alt={image.alt}
              className="w-full h-full object-cover object-top"
              loading="eager"
            >
              <Image.Source
                media={`(min-width: ${theme.screens.lg})`}
                data={{
                  src: image.src,
                  width: pxToNumber(theme.screens['3xl']) / 2,
                }}
              />
              <Image.Source
                media={`(min-width: ${theme.screens.sm})`}
                data={{ src: image.src, width: pxToNumber(theme.screens.lg) }}
              />
            </Image>
          ) : null}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
